import React, { type MouseEventHandler } from "react";

export type AtomButtonProps = {
  buttonText: string | string[];
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  secondaryButtonStyle?: boolean;
  fullWidthButtonStyle?: boolean;
  type?: "submit" | "reset" | "button" | undefined;
};

const AtomButton = ({
  buttonText,
  className,
  disabled,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
  secondaryButtonStyle,
  fullWidthButtonStyle,
  type = "submit",
}: AtomButtonProps) => {
  const buttonSecondaryStyle = `${secondaryButtonStyle ? "btn btn-secondary" : "btn btn-primary"}`;
  const buttonWidthStyle = `${fullWidthButtonStyle ? "btn-full-width" : ""}`;

  return (
    <button
      className={`${buttonSecondaryStyle} ${buttonWidthStyle} ${className || ""}`}
      onClick={onClick}
      disabled={disabled}
      type={type}>
      {buttonText}
    </button>
  );
};

export default AtomButton;
